{
  "projects.archive.restore": "Restore project",
  "projects.trash.title": "Move “{{title}}” to Trash?",
  "projects.trash.description": "The project will leave active and archived views and remain available in Trash for restoration or separately confirmed permanent deletion.",
  "projects.trash.action": "Move to Trash",
  "projects.records.trashTitle": "Move “{{title}}” to Trash?",
  "projects.records.trashGoalDescription": "The archived goal will remain available in Trash for restoration or separately confirmed permanent deletion.",
  "projects.records.trashDecisionDescription": "The archived decision and its options will remain together in Trash for restoration or separately confirmed permanent deletion.",
  "projects.records.trashAction": "Move to Trash",
  "projects.records.trashError": "The record could not be moved to Trash. Try again.",
  "projects.options.title": "Decision options",
  "projects.options.description": "Keep the alternatives and mark at most one as selected so the reasoning remains understandable later.",
  "projects.options.add": "Add option",
  "projects.options.empty": "No alternatives have been recorded yet.",
  "projects.options.selected": "Selected",
  "projects.options.editLabel": "Edit {{title}}",
  "projects.options.deleteLabel": "Remove {{title}}",
  "projects.options.field.title": "Option title",
  "projects.options.field.description": "Notes about this option",
  "projects.options.field.selected": "Mark as selected",
  "projects.options.field.selectedHint": "Selecting this option automatically clears the previous selection.",
  "projects.options.cancel": "Cancel",
  "projects.options.save": "Save option",
  "projects.options.titleRequired": "Enter an option title.",
  "projects.options.saveError": "The option could not be saved. Try again.",
  "projects.options.deleteTitle": "Remove “{{title}}” permanently?",
  "projects.options.deleteDescription": "Only this option will be removed; the decision remains. This option is not sent to Trash and cannot be restored.",
  "projects.options.deleteAction": "Remove permanently",
  "projects.options.deleteError": "The option could not be removed. Try again."
}
